import $ from 'jquery';
import { throttle } from 'lodash';

export default class TopBanner {
  constructor($header) {
    this.$window = $(window);
    this.$body = $('body');
    this.$header = $header;
    this.$content = null;
    this.isVisible = false;
    this.rubicon = 410;
  }

  init() {
    this.$banner = this.$header.find('.js-header-top-banner');

    if (!this.$banner.length) {
      return;
    }

    if (this.$banner.has('iframe').length) {
      this.enable();
    } else {
      this.watch();
    }
  }

  enable() {
    this.$content = this.$banner.find('iframe');

    if (this.$window.scrollTop() <= this.rubicon) {
      this.show();
    }

    this.$window.scroll(throttle(() => {
      const scrolled = this.$window.scrollTop();

      if (this.isVisible && (scrolled > (this.rubicon + this.$banner.outerHeight(true)))) {
        this.hide();
      } else if (!this.isVisible && (scrolled <= this.rubicon) && this.$body.css('position') !== 'fixed') {
        this.show();
      }
    }, 300));
  }

  watch() {
    let isContentInserted = false;

    const watcher = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i += 1) {
        const $addedNodes = $(mutations[i].addedNodes);

        if (!isContentInserted && ($addedNodes.is('iframe') || $addedNodes.has('iframe').length)) {
          isContentInserted = true;

          watcher.disconnect();

          this.enable();

          break;
        }
      }
    });

    watcher.observe(
      this.$banner[0],
      {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false,
      },
    );
  }

  show() {
    this.$banner.css('height', `${this.$content.outerHeight(true)}px`);
    this.isVisible = true;
  }

  hide() {
    this.$banner.css('height', '0px');
    this.isVisible = false;
  }
}
